module.exports = __webpack_public_path__ + "static/8-bffecfb8e6e5ae04be971b2409ab306b.jpeg";